import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import ouibounce from "ouibounce";
import axios from "axios";
import { RingLoader } from "react-spinners"; // Импортируем RingLoader

/* import "./OuibounceModal.css";  */ // Создайте CSS-файл для стилей модального окна

const OuibounceModal = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [widgetHtml, setWidgetHtml] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const lastShown = localStorage.getItem("ouibounceLastShown");
        const oneWeekInMilliseconds = 7 * 24 * 60 * 60 * 1000;

        if (
            !lastShown ||
            Date.now() - new Date(lastShown).getTime() > oneWeekInMilliseconds
        ) {
            const modal = document.getElementById("ouibounce-modal");
            const ouibounceInstance = ouibounce(modal, {
                aggressive: true,
                timer: 0,
                callback: () => {
                    setIsModalVisible(true);
                    fetchWidgetHtml();
                    localStorage.setItem(
                        "ouibounceLastShown",
                        new Date().toISOString()
                    );
                },
            });

            return () => {
                ouibounceInstance.disable();
            };
        }
    }, []);

    useEffect(() => {
        // Выводим содержимое widgetHtml в консоль каждый раз, когда оно обновляется
        /* console.log("Содержимое widgetHtml:", widgetHtml); */
    }, [widgetHtml]);

    const fetchWidgetHtml = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get("/widgetOuibounce");
            setWidgetHtml(response.data.html);
            setIsLoading(false);
        } catch (err) {
            setError(err);
            setIsLoading(false);
        }
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
    };

    return (
        <div>
            {isModalVisible && (
                <div id="ouibounce-modal" className="modal-overlay">
                    <div className="modal-content">
                        <button
                            onClick={handleCloseModal}
                            className="close-button"
                        >
                            ×
                        </button>
                        {isLoading && (
                            <div className="spinner-container">
                                <RingLoader
                                    size={150}
                                    color={"#123abc"}
                                    loading={isLoading}
                                />
                            </div>
                        )}
                        {error && <p>Ошибка загрузки: {error.message}</p>}
                        {!isLoading && !error && (
                            <div
                                dangerouslySetInnerHTML={{ __html: widgetHtml }}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default OuibounceModal;

if (document.getElementById("ouibounce")) {
    const container = document.getElementById("ouibounce");
    const root = createRoot(container);
    root.render(<OuibounceModal />);
}
